import { IoWarningOutline } from "react-icons/io5";
import { css } from "../../../styled-system/css";
import { Center, VStack } from "../../../styled-system/jsx";
import { Button } from "../../components/core/basic/Button";
import { PageContainer } from "../../components/core/basic/PageContainer";
import Loading from "../../components/core/blocks/Loading";
import { useAppSelector } from "../../redux/hooks";
import { useAppsStatus } from "../admin/api/useAppsStatus";
import { useConnectShop } from "./api/useConnectShop";
import Card from "../../components/core/basic/Card";
import { successToast, errorToast } from "../../utils/toasts";

export function Connect() {
  const isStaff = useAppSelector((state) => state.user.is_staff);
  const shop_url = new URLSearchParams(window.location.search).get("shop");
  const connectShopMutation = useConnectShop();
  const appsStatusQuery = useAppsStatus();
  if (appsStatusQuery.isLoading) {
    return <Loading fullPage />;
  }

  if (!appsStatusQuery.isSuccess) {
    throw new Error("Failed to load apps status");
  }

  const shops = appsStatusQuery.data.shopify.shops;

  return (
    <PageContainer>
      {shop_url && !shops.includes(shop_url) && (
        <Card>
          <h4 className={css({ margin: 0 })}>
            Connect shop{" "}
            <strong>
              <i>{shop_url}</i>
            </strong>
            ?
          </h4>
          {isStaff && (
            <VStack
              alignItems="start"
              border={"1px solid {black}"}
              paddingY="medium"
              paddingX={"large"}
              fontSize="medium"
              backgroundColor={"yellow/50"}
            >
              <h5 className={css({ margin: 0 })}>
                <IoWarningOutline className={css({ fontSize: "xxlarge" })} /> Check which account you're connecting to
              </h5>
              As a staff user you can be looking at any account in the system. Make sure the right one is selected
              before connecting the shopify store
            </VStack>
          )}
          <Center marginTop="medium">
            <Button
              isPending={connectShopMutation.isPending}
              onPress={() =>
                connectShopMutation.mutate(
                  { shop: shop_url },
                  {
                    onSuccess: () => {
                      successToast({ message: "Shop connected successfully" });
                      void appsStatusQuery.refetch();
                    },
                    onError: (error) => {
                      errorToast({ message: "Error connecting shop", error });
                    },
                  },
                )
              }
            >
              Connect
            </Button>
          </Center>
        </Card>
      )}
      {shop_url && shops.includes(shop_url) && (
        <Card>
          <h4 className={css({ margin: 0 })}>Shop connected successfully</h4>
          <p>
            <strong>
              <i>{shop_url}</i>
            </strong>{" "}
            is connected
          </p>
        </Card>
      )}
      <Card>
        <h4 className={css({ margin: 0 })}>Shopify connections</h4>
        {shops.length ?
          <figure className={css({ fontSize: "medium" })}>
            <figcaption>Connected Shops:</figcaption>
            <ul>
              {shops.map((shop) => (
                <li key={shop}>{shop}</li>
              ))}
            </ul>
          </figure>
        : <p>No shops currently connected</p>}
        {shop_url && !shops.includes(shop_url) && <VStack alignItems={"start"}></VStack>}
      </Card>
    </PageContainer>
  );
}
